import {
  RETRIEVE_STORAGE_ITEMS,
  CREATE_STORAGE_ITEM,
  UPDATE_STORAGE_ITEM,
  DELETE_STORAGE_ITEM,
  RESTORE_STORAGE_ITEM,
  UPDATE_STORAGE_ITEM_STATUS,
} from "./types";

import storageItemService from "../services/storageItem.service";

export const retrieveStorageItems = (
    keyword = "", page = "", perPage = "", all = true, active = true
  ) =>
  async (dispatch) => {
    try {
      const res = await storageItemService.getAll(
        keyword,
        page,
        perPage,
        all,
        active
      );

      console.log(res);

      dispatch({
        type: RETRIEVE_STORAGE_ITEMS,
        payload: res.data.storageItems,
      });
    } catch (err) {
      console.log(err);
    }
};

export const createStorageItem = (data) => async (dispatch) => {
  try {
    const res = await storageItemService.create(data);

    dispatch({
      type: CREATE_STORAGE_ITEM,
      payload: res.data.storageItemInfo,
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const updateStorageItem = (id, data) => async (dispatch) => {
  try {
    const res = await storageItemService.update(id, data);

    dispatch({
      type: UPDATE_STORAGE_ITEM,
      payload: res.data.storageItemInfo,
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const updateStorageItemStatus = (id, data) => async (dispatch) => {
  try {
    const res = await storageItemService.updateStatus(id, data);

    dispatch({
      type: UPDATE_STORAGE_ITEM_STATUS,
      payload: res.data.storageItems,
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const deleteStorageItem = (id, data) => async (dispatch) => {
  try {
    const res = await storageItemService.deleteStorageItem(id, data);

    dispatch({
      type: DELETE_STORAGE_ITEM,
      payload: res.data.storageItems,
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  }
};

export const restoreStorageItem = (id, data) => async (dispatch) => {
  try {
    const res = await storageItemService.restore(id, data);

    dispatch({
      type: RESTORE_STORAGE_ITEM,
      payload: res.data.storageItems,
    });

    return Promise.resolve(res.data);
  } catch (err) {
    return Promise.reject(err);
  }
};
